module.exports = __webpack_public_path__ + "gb-eng.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/4x3/gb-eng.svg
// module id = 903
// module chunks = 0